export const formatCurrency = (price, options = {}) => {
  const locale = navigator.languages?.[0] || "en-US";

  const formatter = new Intl.NumberFormat(locale, {
    style: "currency",
    ...options,
  });

  return formatter.format(price);
};
